import { render } from "./HorizontalBarChart.vue?vue&type=template&id=e449efb2&scoped=true"
import script from "./HorizontalBarChart.vue?vue&type=script&lang=js"
export * from "./HorizontalBarChart.vue?vue&type=script&lang=js"

import "./HorizontalBarChart.vue?vue&type=style&index=0&id=e449efb2&lang=scss&scoped=true"

import exportComponent from "/builds/retina-v5/principal-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e449efb2"]])

export default __exports__